import { DownloadFile, enqueueSnackbar } from 'actions';
import { DownloadEnergyScoreGeneric, DownloadEnergyScoreNonGeneric } from '../requests/EnergySmartScoreDashboardRequests';

export const EXPORT_SELECTION = 'EXPORT_SELECTION';

const onSetExportSelection = (value) => ({
	type: EXPORT_SELECTION,
	exportList: value
});

export const SetExportSelection = (list) => dispatch => {
	dispatch(onSetExportSelection(list));
};

export const ExportTables = (list, project, generic) => async dispatch => {
	dispatch(enqueueSnackbar({ message: 'Export started...', options: { variant: 'info' } }));
	const request = generic ? DownloadEnergyScoreGeneric : DownloadEnergyScoreNonGeneric;
	await request(list, project).then(response => {
		dispatch(enqueueSnackbar({ message: 'Export finished.', options: { variant: 'success' } }));
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
